export default __webpack_public_path__ + "static/media/icon-affordable-prices.a14b8077.svg";